import guest from "../Middlewares/guest";

import Login from '../../Components/Pages/Auth/Login';
import Register from '../../Components/Pages/Auth/Register';
import ForgotPassword from '../../Components/Pages/Auth/ForgotPassword';
import ResetPassword from '../../Components/Pages/Auth/ResetPassword';

export const routes = [
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: {
            title: 'Sign Up',
            middleware: [
                guest
            ]
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            title: "Sign In",
            middleware: [
                guest
            ]
        }
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: ForgotPassword,
        meta: {
            title: "Forgot Password?",
            middleware: [
                guest
            ]
        }
    },
    {
        path: '/reset-password/:token',
        name: 'reset-password',
        component: ResetPassword,
        meta: {
            title: "Reset Password",
            middleware: [
                guest
            ]
        }
    }
]
